import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildHreflangs, parseLocaleFromPath } from "@/lib/locale";

export default function SEO({ title, description, image }) {
  const location = useLocation();
  const { i18n } = useTranslation();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const hreflangs = buildHreflangs(location.pathname, origin);
  const { locale } = parseLocaleFromPath(location.pathname);
  const ogImage = image || `${origin}/seed/workshop_hero.webp`;

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title}</title>
      <meta name="description" content={description || ""} />
      <link rel="canonical" href={`${origin}${location.pathname}`} />
      {hreflangs.map((h) => (
        <link key={h.locale} rel="alternate" hrefLang={h.locale} href={h.href} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={hreflangs.find((h) => h.locale === "hr")?.href || origin} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="Tambure Žmegač" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
